import { SubGroup } from '../context/product_context'
import { del, get, mountQuery, post, put } from './generic'

interface SubGroupApiData {
    id_sub_grupo: number
    nome: string
    id_grupo: number
}

function ParseSubGroup(data: SubGroupApiData): SubGroup {
    return {
        id: data.id_sub_grupo,
        name: data.nome,
        groupId: data.id_grupo,
    }
}

export async function getSubGroupsByGroupId(
    id_grupo?: number
): Promise<SubGroup[]> {
    const query = mountQuery({ id_grupo })

    const res = await get(`sub-grupo?${query}`)
    return res.data.data.map((sg: SubGroupApiData) => {
        return ParseSubGroup(sg)
    })
}

export async function getSubGroupById(id: number): Promise<SubGroup> {
    const res = await post('sub-grupo/specific', {
        filter: [
            {
                name: 'id_sub_grupo',
                value: [id],
            },
        ],
    })
    return ParseSubGroup(res.data.data.group[0])
}

export async function createSubGroup(
    name: string,
    groupId: number
): Promise<SubGroup> {
    const res = await post(
        'sub-grupo',
        {
            nome: name,
            id_grupo: groupId,
        },
        {
            useRecaptcha: true,
        }
    )
    return ParseSubGroup(res.data.data.sub_group)
}

export async function updateSubGroup(
    id: number,
    name: string,
    groupId: number
): Promise<void> {
    await put(
        'sub-grupo',
        {
            id_sub_grupo: id,
            nome: name,
            id_grupo: groupId,
        },
        {
            useRecaptcha: true,
        }
    )
}

export async function deleteSubGroup(id: number): Promise<void> {
    await del(
        'sub-grupo',
        {
            id_sub_grupo: id,
        },
        {
            useRecaptcha: true,
        }
    )
}
